import API from "./api";

function buildDocumentUploadError(response, documentData, fileName) {
  const detail = documentData?.detail ? `: ${documentData.detail}` : "";
  const baseMessage = documentData?.error || "Document upload failed";

  if (response.status === 504) {
    return `${fileName} could not be uploaded because the server took too long to process it. Try a smaller or re-saved file and upload again.`;
  }

  return `${baseMessage}${detail}`;
}

export async function uploadProfileDocuments({
  profileId,
  documentTypeId,
  documentFiles,
  token,
  createFlow = false,
  onProgress = null,
}) {
  const baseURL = API.defaults?.baseURL || "/api";
  const uploadedFiles = [];

  for (const [index, item] of documentFiles.entries()) {
    const file = item?.file;
    if (!(file instanceof File)) continue;

    onProgress?.({
      current: index + 1,
      total: documentFiles.length,
      fileName: file.name || "profile-document",
    });

    const documentFormData = new FormData();
    documentFormData.append("document_type_key", String(documentTypeId));
    documentFormData.append("documents", file, file.name || "profile-document");
    if (createFlow) {
      documentFormData.append("create_flow", "true");
    }

    const documentResponse = await fetch(`${baseURL}/profiles/${profileId}/documents`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: documentFormData,
    });

    const documentData = await documentResponse.json().catch(() => ({}));
    if (!documentResponse.ok) {
      throw new Error(
        buildDocumentUploadError(
          documentResponse,
          documentData,
          file.name || `Document ${index + 1}`
        )
      );
    }

    if (Array.isArray(documentData?.files)) {
      uploadedFiles.push(...documentData.files);
    }
  }

  return uploadedFiles;
}
